import React from "react";
import Home from "../components/Menu.js";
import Footer from "../components/Footer.js";
import Progress from "../utils/Progress.js";

import { Route, Switch } from "react-router-dom";

export default function Layout(props) {
  const { routes } = props;

  return (
    <>
      <Home />
      <LoadRouters routes={routes} />
      <Progress />
      <Footer />
    </>
  );
}

function LoadRouters({ routes }) {
  return (
    <Switch>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      ))}
    </Switch>
  );
}
